import type { Level } from '../engine/level';
import { isAdmin, isUnlocked, type Progress } from './progress';
import { fitRoot, watchViewport } from './viewport';

export function renderSelect(host: HTMLElement, levels: Level[], progress: Progress, onPick: (l: Level) => void): { destroy(): void } {
  const root = document.createElement('div');
  root.className = 'select';
  const packs = [...new Set(levels.map((l) => l.box))];
  const last = levels.find((l) => l.id === progress.last) ?? levels[0];
  let pack = last?.box ?? packs[0] ?? '';
  root.innerHTML = `<div class="inner"><header><h1>rope-candy</h1><div class="sub">${Object.keys(progress.levels).length} / ${levels.length}${isAdmin() ? ' · 관리자' : ''}</div></header><div class="tabs packs"></div><div class="grid"></div></div>`;
  const packsEl = root.querySelector('.packs')!, grid = root.querySelector('.grid')!;
  const draw = () => {
    packsEl.replaceChildren(...packs.map((p) => { const b = document.createElement('button'); b.className = 'tab' + (p === pack ? ' on' : ''); b.textContent = p; b.onclick = () => { pack = p; draw(); }; return b; }));
    const list = levels.filter((l) => l.box === pack).sort((a, b) => a.n - b.n);
    grid.replaceChildren(...list.map((l) => {
      const rec = progress.levels[l.id]; const locked = !isUnlocked(progress, l, levels);
      const b = document.createElement('button');
      b.className = 'cell' + (rec ? (rec.stars === 3 ? ' perfect' : ' done') : '') + (l.id === progress.last ? ' last' : '') + (locked ? ' locked' : '');
      b.textContent = String(l.n); b.disabled = locked;
      if (!locked) b.onclick = () => onPick(l);
      return b;
    }));
  };
  draw();
  host.replaceChildren(root);
  const unwatch = watchViewport(() => fitRoot(root));
  return { destroy() { unwatch(); root.remove(); } };
}
